import { useDispatch } from "react-redux";

import {
  AdjustBillingRequestBodyType,
  AdjustBillingResponseBodyType,
} from "@intelligems/ig-types";
import { useGetOrg } from "@src/api/organizations/get-organization";
import { setDialog } from "@src/store/slices/global";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { organizationsKeys, subscriptionProductKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

const adjustBilling = async (
  payload: ApiRequest<AdjustBillingRequestBodyType>
) => {
  const resp = await api.post<
    AdjustBillingResponseBodyType,
    AdjustBillingRequestBodyType
  >(`/v2/organizations/adjust-billing`, payload.body);

  return resp.data;
};

export const useAdjustBilling = (dontOpenPaymentLink?: boolean) => {
  const queryClient = useQueryClient();
  const org = useGetOrg();
  const dispatch = useDispatch();
  return useMutation<
    AdjustBillingResponseBodyType,
    Error,
    ApiRequest<AdjustBillingRequestBodyType>,
    any
  >({
    mutationKey: ["adjustBilling"],
    mutationFn: async (payload: ApiRequest<AdjustBillingRequestBodyType>) =>
      adjustBilling(payload),
    onMutate: (payload) => {
      if (["create", "upgrade", "downgrade"].includes(payload.body.action)) {
        dispatch(
          setDialog({ dialog: "upgradeToProfitOptimization", open: false })
        );
        if (!dontOpenPaymentLink) {
          dispatch(
            setDialog({
              dialog: "waitForShopify",
              open: true,
            })
          );
        }
      }
    },
    onSuccess: async (data, payload) => {
      await queryClient.invalidateQueries({
        queryKey: organizationsKeys.orgSummary(org.data.org.id),
      });
      await queryClient.invalidateQueries({
        queryKey: subscriptionProductKeys.all,
      });
      dispatch(
        setDialog({
          dialog: "waitForShopify",
          open: false,
        })
      );
      if (payload.body.action !== "cancel" && data && !dontOpenPaymentLink) {
        window.open(data);
      }
    },
  });
};
